/* eslint-disable import/no-duplicates */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";

import { ptBR } from "date-fns/locale";
import { CheckBox } from "components/checkBoxCommon/styles";
import {
  differenceInMonths,
  endOfMonth,
  getMonth,
  getYear,
  isBefore,
  parse,
  parseISO,
  startOfMonth,
  subDays,
} from "date-fns";

import useConvertStringToDate from "hooks/useConvertStringToDate";
import { useEditarItem } from "services/api/AppWeb_PropostaVendas/editar-item";
import SelectAutocomplete from "components/SelectAutocomplete";

import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import * as Styles from "./styles";
import * as SVGIcons from "../../../../../../../../../assets/iconsSVG";
import MaterialUI from "../../../../../../../../../material-UI";

interface SelectedRowsProps {
  dataVencimento: string;
  fixo: boolean;
  frequencia: number;
  idSerie: string;
  juros: boolean;
  qtdParcelas: number;
  tipoSerie: number;
  valorParcela: number;
  valorTotal: number | null | undefined;
}

interface Props {
  onClose: () => void;
  tableData: any;
  refetch: () => void;
  selectedRow?: SelectedRowsProps;
  dataDetalheOportunidade?: any;
}

const TipoSerieEnum = {
  "100000000": "Sinal",
  "100000005": "Inicial",
  "100000001": "Parcelas",
  "100000002": "Unica",
  "100000003": "Financiamento",
  "100000012": "Alienação Fiduciária",
  "100000004": "Credito Associativo",
  "100000013": "Comissão",
  "100000014": "Dação",
  "100000015": "Migração",
  "100000016": "Bônus",
};

const FrequenciaEnum = {
  "100000000": "Mensal",
  "100000001": "Bimestral",
  "100000002": "Trimestral",
  "100000003": "Quadrimestral",
  "100000004": "Semestral",
  "100000005": "Unica",
  "100000006": "Anual",
};

const Footer: React.FC<Props> = (props) => {
  const params: any = useParams();
  const [tipoSerie, setTipoSerie] = useState<any>(null);
  const [tipoSerieList, setTipoSerieList] = useState<any[]>([]);
  const [qtdParcelas, setQtdParcelas] = useState<any>(null);
  const [qtdsParcelasList, setQtdsParcelasList] = useState<any[]>([]);
  const [frequencia, setFrequencia] = useState<any>(null);
  const [valorParcela, setValorParcela] = useState<string>("");
  const [dataVencimento, setDataVencimento] = useState<any>(null);
  const [juros, setJuros] = useState(false);
  const [jurosDisabled, setJurosDisabled] = useState(false);
  const [fixo, setFixo] = useState(false);
  const [fixoDisabled, setFixoDisabled] = useState(false);
  const [dataVencimentoDisabled, setDataVencimentoDisabled] = useState(false);
  const tipoSerieArray = Object.entries(TipoSerieEnum).map(
    ([value, label]) => ({ label, value })
  );
  const frequenciaArray = Object.entries(FrequenciaEnum).map(
    ([value, label]) => ({ label, value })
  );

  const [frequenciaList, setFrequenciaList] = useState<any[]>(frequenciaArray);

  const diasPermitidos = [10, 15, 20, 25];

  const validarDiaPermitido = (date: Date) => {
    return diasPermitidos.includes(date.getDate());
  };

  const formatCurrencyString = (value: string) => {
    const cleanedValue = value.replace(/[^\d.]/g, "");
    const numberValue = parseFloat(cleanedValue);
    const formattedValue = numberValue.toFixed(2).replace(".", ",");
    return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  useEffect(() => {
    if (props?.selectedRow) {
      setValorParcela(
        formatCurrencyString(props?.selectedRow?.valorParcela.toString())
      );
      setTipoSerie(props?.selectedRow?.tipoSerie.toString());
      setFrequencia(props?.selectedRow?.frequencia.toString());
      setQtdParcelas({
        value: props?.selectedRow?.qtdParcelas.toString(),
        label: props?.selectedRow?.qtdParcelas.toString(),
      });
      setDataVencimento(props?.selectedRow?.dataVencimento);
      setFixo(props?.selectedRow?.fixo);
      setJuros(props?.selectedRow?.juros);
    }
  }, [props?.selectedRow]);

  function gerarNumeroParcelas(numeroParcelas: any) {
    const parcelasArray: any[] = [];
    for (let i = 1; i <= numeroParcelas; i++) {
      parcelasArray.push({
        label: `${i}`,
        value: `${i}`,
      });
    }
    setQtdsParcelasList(parcelasArray);
  }

  const calcularNumeroParcelas = (dateVencimento: any) => {
    const hoje = startOfMonth(new Date(dataVencimento));
    const vencimento = startOfMonth(new Date(dateVencimento));

    let totalMeses = differenceInMonths(vencimento, hoje);
    if (vencimento >= hoje) {
      totalMeses += 1;
    }

    const totalParcelas = totalMeses > 0 ? totalMeses : 360;

    return totalParcelas;
  };

  const dataConvertida = useConvertStringToDate(
    props?.tableData?.dataEntregaEmpreendimento
  );

  useEffect(() => {
    if (props?.tableData?.serie?.serieTabela) {
      const tiposSerieNaTable = props?.tableData?.serie?.serieTabela.map(
        (item: any) => item.tipoSerie.toString()
      );

      let tiposFiltrados = tipoSerieArray.filter(
        (item) => !tiposSerieNaTable.includes(item.value)
      );

      const dataAtual = new Date();
      if (dataConvertida) {
        if (dataConvertida < dataAtual) {
          const tiposPermitidos = [
            "100000000",
            "100000002",
            "100000003",
            "100000004",
            "100000005",
            "100000012",
          ];
          tiposFiltrados = tiposFiltrados.filter((item) =>
            tiposPermitidos.includes(item.value)
          );
        }
      }

      const tiposSemprePermitidos = [
        "100000001",
        "100000013",
        "100000014",
        "100000015",
        "100000016",
      ];
      const tiposAdicionais = tipoSerieArray.filter((item) =>
        tiposSemprePermitidos.includes(item.value)
      );

      tiposFiltrados = [
        ...tiposFiltrados,
        ...tiposAdicionais.filter(
          (item) =>
            !tiposFiltrados.some((filtrado) => filtrado.value === item.value)
        ),
      ];

      const hasAlienacaoFiduciaria = tiposSerieNaTable.includes("100000012");
      const hasFinanciamento = tiposSerieNaTable.includes("100000003");

      if (hasAlienacaoFiduciaria) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000003"
        );
      } else if (hasFinanciamento) {
        tiposFiltrados = tiposFiltrados.filter(
          (item) => item.value !== "100000012"
        );
      }

      if (props?.selectedRow?.tipoSerie.toString() === "100000003") {
        tiposFiltrados.push({
          value: "100000003",
          label: TipoSerieEnum["100000003"],
        });
      }

      if (props?.selectedRow?.tipoSerie.toString() === "100000012") {
        tiposFiltrados.push({
          value: "100000012",
          label: TipoSerieEnum["100000012"],
        });
      }

      if (props?.selectedRow?.tipoSerie.toString() === "100000000") {
        tiposFiltrados.push({
          value: "100000000",
          label: TipoSerieEnum["100000000"],
        });
      }
      if (props?.selectedRow?.tipoSerie.toString() === "100000004") {
        tiposFiltrados.push({
          value: "100000004",
          label: TipoSerieEnum["100000004"],
        });
      }
      if (props?.selectedRow?.tipoSerie.toString() === "100000005") {
        tiposFiltrados.push({
          value: "100000005",
          label: TipoSerieEnum["100000005"],
        });
      }
      if (props?.selectedRow?.tipoSerie.toString() === "100000002") {
        tiposFiltrados.push({
          value: "100000002",
          label: TipoSerieEnum["100000002"],
        });
      }

      setTipoSerieList(tiposFiltrados);
    }
  }, [
    props?.tableData?.serie?.serieTabela,
    props?.tableData?.dataEntregaEmpreendimento,
    dataConvertida,
  ]);

  // useEffect(() => {
  //   if (dataConvertida && dataConvertida > new Date()) {
  //     if (tipoSerie === "100000001" && dataVencimento > dataConvertida) {
  //       setJuros(true);
  //       setJurosDisabled(true);
  //     } else {
  //       setJurosDisabled(false);
  //     }
  //   }
  // }, [dataVencimento]);

  const handleJuros = (value: boolean) => {
    setJuros(value);
    const dataJuros = new Date(props?.tableData?.serie?.dataJuros);
    if (
      value === true &&
      dataJuros &&
      getMonth(dataJuros) === getMonth(dataVencimento) &&
      getYear(dataJuros) === getYear(dataVencimento)
    ) {
      toast.error(
        "Mês e ano do vencimento igual a data de chaves, nesse caso remova a flag de Juros"
      );
      return;
    }
    if (dataJuros && dataJuros > new Date()) {
      if (dataVencimento > dataJuros && value === false) {
        toast.error("Parcelas após a entrega das chaves devem incluir juros", {
          autoClose: 10000,
        });
      } else if (dataVencimento < dataJuros && value) {
        toast.error(
          "Séries anteriores ou iguais à data de juros não podem ter TP. Retire a flag da opção juros nestes casos."
        );
      }
    }
  };

  const handleVencimento = (value: any) => {
    setQtdParcelas(null);
    if (value && validarDiaPermitido(value)) {
      setDataVencimento(value);
      const dataJuros = new Date(props?.tableData?.serie?.dataJuros);
      if (dataJuros && dataJuros > new Date()) {
        if (startOfMonth(value) > startOfMonth(dataJuros)) {
          setJuros(true);
        } else {
          setJuros(false);
        }
      }
    }
  };

  const tipoSerieData = props?.tableData?.serie?.serieTabela.find(
    (item: any) => item.tipoSerie === 100000000
  );
  const minimunDate = tipoSerieData
    ? parseISO(tipoSerieData.dataVencimento)
    : new Date();

  const calculateMaximunDate = () => {
    if (tipoSerie?.toString() === "100000000") {
      return new Date();
    }
    return null;
  };

  useEffect(() => {
    const tiposValidos = [
      "100000000",
      "100000002",
      "100000003",
      "100000004",
      "100000005",
      "100000012",
    ];
    if (tipoSerie) {
      if (tipoSerie === "100000001" && dataConvertida) {
        const numeroParcelas = calcularNumeroParcelas(dataConvertida);
        gerarNumeroParcelas(numeroParcelas);
      } else if (
        tiposValidos.includes(tipoSerie) ||
        frequencia === "100000005"
      ) {
        gerarNumeroParcelas(1);
        if (qtdParcelas?.value !== "1") {
          setQtdParcelas({
            value: "1",
            label: "1",
          });
        }
        setFrequencia("100000005");
      } else {
        gerarNumeroParcelas(360);
      }
    }
  }, [tipoSerie, dataConvertida, dataVencimento]);

  useEffect(() => {
    if (tipoSerie === "100000002") {
      if (dataConvertida) {
        const dataEntrega = new Date(dataConvertida);
        dataEntrega.setDate(25);
        setDataVencimento(dataEntrega);
      }
      setDataVencimentoDisabled(true);
    } else {
      setDataVencimento(new Date(props?.selectedRow?.dataVencimento ?? ""));
      setDataVencimentoDisabled(false);
    }
  }, [tipoSerie, dataConvertida]);

  useEffect(() => {
    if (tipoSerie === "100000000") {
      setDataVencimento(new Date());
      setDataVencimentoDisabled(true);
      setFixo(true);
      setFixoDisabled(true);
    } else {
      setFixoDisabled(false);
      setFixo(false);
    }
  }, [tipoSerie]);

  const onHandleFrequencia = (value: any) => {
    setFrequencia(value);
    if (dataConvertida && dataConvertida > new Date()) {
      const numeroParcelas = calcularNumeroParcelas(dataConvertida);
      let parcelas = 0;

      switch (value) {
        case "100000005":
          parcelas = 1;
          break;
        case "100000000":
          parcelas = numeroParcelas;
          break;
        case "100000001":
          parcelas = Math.ceil(numeroParcelas / 2);
          break;
        case "100000002":
          parcelas = Math.ceil(numeroParcelas / 3);
          break;
        case "100000003":
          parcelas = Math.ceil(numeroParcelas / 4);
          break;
        case "100000004":
          parcelas = Math.ceil(numeroParcelas / 6);
          break;
        case "100000006":
          parcelas = Math.ceil(numeroParcelas / 12);
          break;
        default:
          parcelas = 0;
      }

      gerarNumeroParcelas(parcelas);

      if (qtdParcelas !== null && parcelas < parseInt(qtdParcelas.value, 10)) {
        setQtdParcelas(null);
      }
      if (parcelas === 1) {
        setQtdParcelas({
          value: "1",
          label: "1",
        });
      }
    } else {
      gerarNumeroParcelas(360);
    }
  };

  const formatCurrency = (value: string) => {
    const cleanedValue = value.replace(/\D/g, "");
    const formattedValue = (Number(cleanedValue) / 100).toFixed(2);
    return `${formattedValue
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  };

  const handleValorParcelaChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    setValorParcela(formatCurrency(value));
  };

  const mutate = useEditarItem({
    idUnidade: props.tableData?.idUnidade,
    idSerie: props?.selectedRow?.idSerie ? props?.selectedRow?.idSerie : "",
    tipoSerie,
    qtdParcelas: qtdParcelas?.value,
    frequencia,
    valorParcela,
    dtVencimento: dataVencimento,
    juros,
    fixo,
    idLeadCorretor: params.idLeadCorretor,
    idOportunidade: props?.dataDetalheOportunidade?.idOportunidade,
  });

  const handleClick = () => {
    if (!validarDiaPermitido(dataVencimento) && tipoSerie !== "100000000") {
      toast.error(
        "Apenas os dias 10, 15, 20 ou 25 são permitidos para vencimento"
      );
      return;
    }

    // Verificar se a data selecionada é anterior à data do Sinal
    if (
      tipoSerie !== "100000000" &&
      dataVencimento &&
      minimunDate &&
      isBefore(dataVencimento, minimunDate)
    ) {
      toast.error("A data de vencimento não pode ser anterior à data do Sinal");
      return;
    }

    const dataJuros = new Date(props?.tableData?.serie?.dataJuros);
    if (juros === true && dataVencimento < dataJuros) {
      toast.error(
        "Séries anteriores ou iguais à data de juros não podem ter TP. Retire a flag da opção juros nestes casos."
      );
      return;
    }
    if (
      dataJuros &&
      getMonth(dataJuros) === getMonth(dataVencimento) &&
      getYear(dataJuros) === getYear(dataVencimento) &&
      juros
    ) {
      toast.error(
        "Mês e ano do vencimento igual a data de chaves, nesse caso remova a flag de Juros"
      );
      return;
    }
    mutate.mutate();
  };

  useEffect(() => {
    if (mutate.isSuccess) {
      props.onClose();
      props.refetch();
    }
  }, [mutate.isSuccess]);

  return (
    <>
      <Styles.Container>
        <Styles.Item style={{ width: "40%" }}>
          <Styles.Label>Tipo série</Styles.Label>
          <Styles.StyledSelect
            value={tipoSerie}
            size="small"
            onChange={(e) => setTipoSerie(e.target.value as string)}
          >
            {tipoSerieList.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{ fontSize: "14px" }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Styles.StyledSelect>
        </Styles.Item>
        <Styles.Item style={{ width: "20%" }}>
          <SelectAutocomplete
            data={qtdsParcelasList}
            label="Qtd. Parcelas"
            onChange={(value) => setQtdParcelas(value)}
            value={qtdParcelas}
            disabled={
              [
                "100000000",
                "100000002",
                "100000003",
                "100000004",
                "100000005",
                "100000012",
              ].includes(tipoSerie) || !tipoSerie
            }
          />
        </Styles.Item>
        <Styles.Item style={{ width: "40%" }}>
          <Styles.Label>Frequência</Styles.Label>

          <Styles.StyledSelect
            value={frequencia}
            size="small"
            onChange={(e) => onHandleFrequencia(e.target.value as string)}
            disabled={[
              "100000000",
              "100000002",
              "100000003",
              "100000004",
              "100000005",
              "100000012",
            ].includes(tipoSerie)}
          >
            {frequenciaList.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{ fontSize: "14px" }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Styles.StyledSelect>
        </Styles.Item>
      </Styles.Container>
      <Styles.Container style={{ marginTop: "20px" }}>
        <Styles.Item>
          <Styles.Label>Valor Parcela</Styles.Label>

          <Styles.StyledTextField
            value={valorParcela}
            size="small"
            placeholder="R$"
            onChange={handleValorParcelaChange}
          />
        </Styles.Item>
        <Styles.Item>
          <Styles.Label>Vencimento</Styles.Label>
          <Styles.LocalizationProvider
            locale={ptBR}
            dateAdapter={MaterialUI.AdapterDateFns}
          >
            <Styles.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={dataVencimento}
              components={{
                OpenPickerIcon: SVGIcons.CalendarSelectIcon,
              }}
              disabled={dataVencimentoDisabled}
              minDate={minimunDate}
              maxDate={calculateMaximunDate()}
              shouldDisableDate={(date: any) => !validarDiaPermitido(date)}
              InputAdornmentProps={{ position: "start" }}
              onChange={(newValue: any) => handleVencimento(newValue)}
              renderInput={(params: any) => (
                <Styles.StyledTextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label=" "
                  fullWidth
                />
              )}
            />
          </Styles.LocalizationProvider>
        </Styles.Item>
      </Styles.Container>
      <Styles.ContainerCheckBox>
        <div
          style={{ display: "flex", margin: "10px 0", alignItems: "center" }}
        >
          <CheckBox
            checked={juros}
            onChange={(e) => handleJuros(e.target.checked)}
            disabled={jurosDisabled}
          />
          <Styles.Label>Juros</Styles.Label>
          <CheckBox
            checked={fixo}
            disabled={fixoDisabled}
            onChange={(e) => setFixo(e.target.checked)}
          />
          <Styles.Label>Fixo</Styles.Label>
        </div>
      </Styles.ContainerCheckBox>
      <Styles.SecondContainer>
        <Styles.Button onClick={props.onClose}>
          <Styles.LightTextBlue>Cancelar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          disabled={
            !frequencia || !qtdParcelas || !valorParcela || !dataVencimento
          }
          onClick={() => {
            handleClick();
          }}
        >
          {mutate?.isLoading ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightText>Salvar</Styles.LightText>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
